import { gql } from "@apollo/client";
import { ATTENTION_FRAGMENT, AttentionLog } from "./getAttentionLogs";


export const DISMISS_ATTENTION_LOG = gql`
  mutation DismissAttentionLog($domain: String!, $logs: [Int!]!) {
    controller {
      dismissAttentionLog(domain: $domain, logs: $logs) {
        ...AttentionFields
      }
    }
  }
  ${ATTENTION_FRAGMENT}
`

export interface DismissAttentionLogResponse {
  controller: {
    dismissAttentionLog: AttentionLog
  }
}